import { filter, isEmpty, pick, split } from 'lodash'

const transformToUpdateDishTypeSimpleDetailsArgs = data => ({
  ...pick(data, [
    'description',
    'position',
    'isExcludedFromSearch',
    'isExcludedFromBrowsing',
  ]),
  synonyms: filter(split(data.synonyms, '\n'), synonym => !isEmpty(synonym)),
})

export default transformToUpdateDishTypeSimpleDetailsArgs
